var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashcan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 6.5C8 6.22386 8.22386 6 8.5 6C8.77614 6 9 6.22386 9 6.5V10.5C9 10.7761 8.77614 11 8.5 11C8.22386 11 8 10.7761 8 10.5V6.5Z",
    fill: "#001A39"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 6C5.22386 6 5 6.22386 5 6.5V10.5C5 10.7761 5.22386 11 5.5 11C5.77614 11 6 10.7761 6 10.5V6.5C6 6.22386 5.77614 6 5.5 6Z",
    fill: "#001A39"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 1C3 0.516751 3.34278 0.113563 3.79847 0.0203164C3.86356 0.00699555 3.93096 0 4 0H10C10.5178 0 10.9436 0.3935 10.9948 0.897756C10.9983 0.931373 11 0.965482 11 1V3H13C13.5523 3 14 3.44772 14 4C14 4.55228 13.5523 5 13 5V13C13 13.5523 12.5523 14 12 14H2C1.44772 14 1 13.5523 1 13L1 5C0.447716 5 0 4.55229 0 4C0 3.44772 0.447715 3 1 3L3 3V1ZM5 3H9V2L5 2V3ZM3 5V12H11V5H3Z",
    fill: "#001A39"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashcan);
export default __webpack_public_path__ + "static/media/Trashcan.7d7da7722a9720642feab4e31bdc6ee3.svg";
export { ForwardRef as ReactComponent };